import Duck from "redux-ducks-ts"

export const authorization = new Duck("authorization", "cargo")
